module.exports = __webpack_public_path__ + "img/top-0-3.e8d614d7.jpg";